module.exports = __webpack_public_path__ + "static/media/mobile_stories_2x.fc95f853.png";